import { useSearchParams } from 'react-router-dom'

import { useResumeFontSizeDebugMode } from './useResumeFontSizeDebugMode'
import { useResumeLineGuidesMode } from './useResumeLineGuidesMode'

/** Combined preview debug flags from URL (lineGuides + fontSizes work together). */
export type ResumePreviewDebugModes = {
  lineGuides: boolean
  fontSizeDebug: boolean
  any: boolean
}

/** Canonical combo: `?lineGuides=1&fontSizes=1` on resume detail. */
export function useResumePreviewDebugModes(): ResumePreviewDebugModes {
  const lineGuides = useResumeLineGuidesMode()
  const fontSizeDebug = useResumeFontSizeDebugMode()
  return {
    lineGuides,
    fontSizeDebug,
    any: lineGuides || fontSizeDebug,
  }
}
